import { SEOCompletor, Metadata, OpenGraphTypes, TwitterCardTypes, TouchedFields } from '@/modules/seo/types'
import store from '@/store'
import Store from '@/modules/core/vuex/Store'
import { RootState } from '@/store/types'
import { Post } from '@/modules/blog/types';

/**
 * Completa los metadatos SEO en base a la información de la publicación actual
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.e>
 */
export default class PostSEOCompletor implements SEOCompletor {

    /**
     * Constructor
     *
     * @param store {Store}
     */
    constructor (private store: Store<RootState>) {}

    /**
     * Permite acceder a la publicación actualmente en edición, almacenada
     * en el estado
     */
    private get post (): Post {
        return this.store.get('blog.editingPost', new Post())
    }

    /**
     * Permite acceder acceder a la traducción actual de la publicación
     * actualmente en edición, almacenada en el estado
     */
    private get currentTranslation (): string {
        return this.store.get('blog.currentTranslation', '')
    }

    /**
     * @inheritDoc
     */
    public complete (metatada: Metadata, currentLocale: string): Metadata {
        const translation = metatada.translate(currentLocale)

        // Si la traducción no existe se termina el proceso
        if (!translation) {
            return metatada
        }

        const postTranslation = this.post.getTranslation(this.currentTranslation)
        if (!postTranslation) {
            return metatada
        }

        translation.title = postTranslation.title
        translation.description = postTranslation.shortDescription
        translation.keywords = this.post.tags

        const opengraph = translation.opengraph
        opengraph.title = postTranslation.title

        if (opengraph.type === OpenGraphTypes.Article) {
            const article = opengraph.article
            article.tags = this.post.tags
            article.author.firstName = this.post.author.name

            opengraph.article = article
            translation.opengraph = opengraph
        }

        const twitter = translation.twitter
        if (twitter.type !== TwitterCardTypes.None) {
            twitter.title = translation.title
            twitter.description = translation.description
        }


        return metatada
    }

    /**
     * @inheritDoc
     */
    public initFields (metatada: Metadata, touchedFields: TouchedFields): TouchedFields {
        return touchedFields
    }
}

export function buildPostSEOCompletor () {
    return new PostSEOCompletor(store)
}
